import { generateShortId } from '..'
import { Coordinates } from './Coordinates'
import { Route } from './Route'

export interface LiveDriver {
  uid: string;
  position: Coordinates | null;
  positionTime: number | null;
}

export interface LivePlaceTimes {
  arrival: number;
  departure: number;
}

export interface LiveData {
  driverSecret: string;
  driving: boolean;
  latestIndex: number;
  latestTime: number;
  driver: LiveDriver | null;
  places: LivePlaceTimes[];
}

export class LiveDriverModel implements LiveDriver {
  uid: string;
  position: null;
  positionTime: null;
  constructor(uid: string) {
    this.uid = uid
  }
}

export const liveDataModel = (route: Route): LiveData => {
  return {
    driverSecret: generateShortId(),
    driving: false,
    latestIndex: 0,
    latestTime: 0,
    driver: null,
    places: Array<LivePlaceTimes>(route.places.length).fill({
      arrival: 0,
      departure: 0
    })
  }
}